import useTranslator from "../../../../hooks/useTranslator";
import { Button, Card, Icon } from "../../../../components/design";
import styles from "../authenticateYourId.module.css";

const VerificationStartScreen = ({
  onStart,
  isLoading = false,
  isTenantCheck = false,
}: {
  onStart: () => void;
  isLoading?: boolean;
  isTenantCheck?: boolean;
}) => {
  const { _t } = useTranslator();

  const expectations = [
    {
      icon: "camera" as const,
      text: _t("takeAPhotoOfYourDocumentOrUploadItFromYourDevice"),
    },
    {
      icon: "user" as const,
      text: _t("theDocumentMustIncludeYourPhotoANieWithoutAPhotoIsNotValid"),
    },
    {
      icon: "clock" as const,
      text: _t("theResultIsUsuallyReadyInLessThanAMinute"),
    },
  ];

  return (
    <div className={styles.kycVerificationStart}>
      <div className={styles.kycVerificationStartIcon} aria-hidden="true">
        <Icon name="idCard" size={36} />
      </div>

      <div className={styles.kycVerificationStartCopy}>
        <h3>
          {isTenantCheck
            ? _t("verifyYourIdentityForCheck")
            : _t("verifyYourIdentity")}
        </h3>
        <p>
          {isTenantCheck
            ? _t("haveYourDniPassportOrResidenceCardReadyForCheck")
            : _t("haveYourDniPassportOrResidenceCardReady")}
        </p>
      </div>

      <Card as="div" className={styles.kycVerificationExpectations}>
        {expectations.map(({ icon, text }, index) => (
          <div className={styles.kycVerificationExpectation} key={index}>
            <span className={styles.kycVerificationExpectationIcon}>
              <Icon name={icon} size={18} />
            </span>
            <span>{text}</span>
          </div>
        ))}
      </Card>

      <div className={styles.kycVerificationStartActions}>
        <div className={styles.kycVerificationStartButtonPanel}>
          <Button
            size="lg"
            block
            className={`notranslate ${styles.kycVerificationStartButton}`}
            onClick={onStart}
            loading={isLoading}
            translate="no"
          >
            <span hidden={isLoading}>{_t("startVerification")}</span>
            <span hidden={!isLoading}>{_t("startingVerification")}</span>
          </Button>
        </div>

        <p className={styles.kycVerificationLegal}>
          {_t("identityVerificationAmlLegalCopy")}{" "}
          <a
            href="https://skortorent.com/legal-notice.html"
            target="_blank"
            rel="noreferrer"
          >
            {_t("moreInformation")}
          </a>
        </p>

        <div className={styles.kycVerificationEncryptedNote}>
          <Icon name="lock" size={16} />
          <span>{_t("yourDataIsEncrypted")}</span>
        </div>
      </div>
    </div>
  );
};

export default VerificationStartScreen;
